module.exports = __webpack_public_path__ + "static/media/logo152.ba90e5df.png";